import React from 'react';
import {
    StyledContentWrapper,
    StyledTitleSection
} from './style/TitleSection.styled';
import { StyledH1, StyledSubtitle } from '../../../Title/styles/Title.styled';
import { SubscriptionButton } from '../../../ButtonLink/components/SubscriptionLink';
import { SubscriptionFares } from '../../../../lib/enums';

export const TitleSection = () => {
    return (
        <StyledTitleSection>
            <StyledContentWrapper>
                <StyledH1>
                    ZAYCEV.NET<span> - одна подписка на все приложения</span>
                </StyledH1>
                <StyledSubtitle>
                    Подписка действует на сайте и в приложении на всех
                    устройствах
                </StyledSubtitle>
                <SubscriptionButton
                    type={SubscriptionFares.MONTH}
                    text="Оформить подписку за 99 ₽/месяц"
                />
            </StyledContentWrapper>
            {/* <StyledTitleSectionAsidePicture /> */}
        </StyledTitleSection>
    );
};
